import {gsap, ScrollTrigger} from "../LibrariesImport";

export default class BlockBanner {
	static init() {

		let btnToggleForm = document.querySelector('.js-toggle-form');
		let btnCloseForm = document.querySelector('.js-close-form');
		let formContainer = document.querySelector('.lead-container');
		let formOverlay = document.querySelector('.lead-overlay');

		if( !formContainer ){
			return;
		}

		btnToggleForm.addEventListener('click', (e) => {
			e.preventDefault();
			formContainer.classList.toggle('show');
			formOverlay.classList.toggle('show', formContainer.classList.contains('show'));
		});

		btnCloseForm.addEventListener('click', (e) => {
			e.preventDefault();
			btnToggleForm.click();
		});

		let scrollToFooter = document.querySelectorAll('.js-scroll-to-footer');
		scrollToFooter.forEach( (btn) => {
			btn.addEventListener( 'click', (e) => {
				gsap.to(window, {
					duration: 0.2,
					scrollTo: ".footer-main",
					ease: "none"
				});
			});
		});

	}
}
